export default __webpack_public_path__ + "static/media/Delete02.2e987f0a.svg";